<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("customization") }}</div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'F&B Customization')"
          variant="default"
          to="add-customization"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="searchCustomization"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="(filterIsActive) => getCustomizationList(filterIsActive)"
        />
        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <table class="list-view-table">
      <thead>
        <tr>
          <th class="text-left" style="width: 150px">
            <span class="pr-5">{{ $tc("status", 2) }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'item_name'"
              @click="onSortValue('item_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('item_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('item_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("customizationName") }}
          </th>
        </tr>
      </thead>
      <tbody v-if="customizations && customizations.length > 0">
        <tr
          v-for="(customization, customizationIndex) in customizations"
          :key="customizationIndex"
        >
          <!-- <td>
            <div class="d-flex align-items-center justify-content-start">
              <label class="ios-switch">
                <input
                  :checked="customization.item_is_active == 'Y' ? true : false"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label>

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  v-if="$can('update', 'F&B Customization')"
                  @click="goToRoute('/fnb/edit-customization', customization)"
                >
                  <span class="edit-pen"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/fnb/view-customization', customization)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox
                :checked="customization.item_is_active == 'Y' ? true : false"
                type="checkbox"
                class="j-checkbox ml-2"
                disabled
              />
              <!-- <span class="switch-slider"></span>
              </label> -->
              <div
                v-if="$can('update', 'F&B Customization')"
                class="ml-4 clickable-icon"
                @click="goToRoute('/fnb/edit-customization', customization)"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </div>
              <div
                class="ml-2 clickable-icon"
                @click="goToRoute('/fnb/view-customization', customization)"
                style="cursor: pointer"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <i class="icon-eye icon blue-icon"></i>
              </div>
            </div>
          </td>
          <td>{{ customization.item_name }}</td>
        </tr>
      </tbody>

      <tbody v-else>
        <td colspan="2">
          <NoRecords />
        </td>
      </tbody>
    </table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      cinema_id: null,
      selectedvalue: "10",
      gridView: false,
      listView: true,
      customizations: [],
      searchValue: "",
      searchKey: "Customization Name",
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  beforeMount() {
    this.getviewingnumber();
  },
  mounted() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.cinema_id = obj;
    this.getCustomizationList();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    searchCustomization() {
      this.getCustomizationList();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getCustomizationList();
      } else {
        this.currentPage = event;
        this.getCustomizationList();
      }
    },

    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getCustomizationList();
    },
    getCustomizationList(filterIsActive = "Y") {
      this.customizations = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        cinema_id: this.cinema_id,
        columnName: this.columnName,
        orderBy: this.orderby,
        filterIsActive,
      };
      PosFnbService.GetCustomizationList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.customizations = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
              this.selectedvalue =
                this.selectedvalue < 10 ? 10 : this.selectedvalue;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else {
            this.customizations = [];
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    // goToRoute: function(path, { customization_common_id }) {
    //   this.$router.push({
    //     path: path,
    //     query: {
    //       customization_common_id: customization_common_id
    //     }
    //   });
    // },
    goToRoute: function (path, { item_code }) {
      this.$router.push({
        path: path,
        query: {
          item_code: item_code,
        },
      });
    },
    /* eslint-disable */

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/customizationComponents/customizationV2.vue